import { TAssetEditorProp } from '../../assetEditorProps'
import { checkTypeValue } from '../../../../../utils'
import { AMAPPEffectsTypes, isCamera, utilsEditor } from '@amaspace-editor/editor-3d'
import { AMAPPUpdate } from '@amaspace-editor/editor-3d/dist/lib/types/state.types'

const sceneActions = (key: string, value: TAssetEditorProp['value'], editor3D: ReturnType<typeof utilsEditor>) => {
    const keyProp = key.split('_').slice(-1)[0]
    const keyValue = key.split('_')[0]

    if (keyProp === 'camera') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeCamera)
        if (!isCamera(current)) return
        editor3D.updateObjectData(editor3D.activeCamera, {
            updatedCamera: {
                ...current.updatedCamera,
                [keyValue]: value
            }
        })
        if (value?.isVector3) {
            //@ts-ignore
            editor3D.getCamera()[keyValue].copy(value)
            return
        }
        //@ts-ignore
        editor3D.getCamera()[keyValue] = +value
    }
    if (keyProp === 'controls') {
        const current = editor3D.getCurrentConfigObj(editor3D.activeCamera)
        if (!isCamera(current)) return
        //@ts-ignore
        editor3D.controls[keyValue] = +value
        editor3D.updateObjectData(editor3D.activeCamera, {
            updatedControls: {
                ...current.updatedControls,
                [keyValue]: +value
            }
        })
    }
    if (key === 'grid') {
        editor3D.toggleGrid(value)
    }
    if (key === 'animateCamera') {
        editor3D.setAnimateCamera(value)
    }
    if (keyProp === 'env') {
        editor3D.setActiveEnvironment({ ...editor3D.activeEnvironment, [keyValue]: value })
    }
    if (key === 'post_processing') {
        editor3D.updatePostProcessing(value)
    }
    if (keyProp === 'pp') {
        editor3D.updatePostProcessing(editor3D.postProcessing.name, {
            ...editor3D.postProcessing.effect,
            [keyValue]: {
                //@ts-ignore
                ...editor3D.postProcessing.effect[keyValue],
                value: value
            }
        })
    }
    if (key === 'background') {
        if (!checkTypeValue<string>(value)) return
        editor3D.changeBackgroundColor(value)
    }
    if (key === 'camera_position') {
        const defaultCamera = editor3D.config.customObjects.find(x => x.type === 'Default_Camera')
        const cameraConfig = editor3D.getCurrentConfigObj(editor3D.getCamera())
        if (!isCamera(defaultCamera)) return

        editor3D.setDefaultCameraPosition({
            cameraId: cameraConfig!.id,
            cameraPos: defaultCamera!.position.clone(),
            cameraTarget: defaultCamera!.target!.position!.clone()
        } as any)
    }
    if (key === 'camera') {
        const id = value.split('_')[0]
        editor3D.threeState?.scene.traverse(x => {
            if (x.userData.id === id) {
                editor3D.setActiveCamera(x)
                editor3D.unselect()
            }
        })
    }
}
export { sceneActions }
